var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60547 4.19229C1.60547 3.57926 1.84899 2.99134 2.28247 2.55786C2.71595 2.12438 3.30387 1.88086 3.9169 1.88086H17.7855C18.3985 1.88086 18.9864 2.12438 19.4199 2.55786C19.8534 2.99134 20.0969 3.57926 20.0969 4.19229V13.438C20.0969 14.051 19.8534 14.639 19.4199 15.0724C18.9864 15.5059 18.3985 15.7495 17.7855 15.7495H3.9169C3.30387 15.7495 2.71595 15.5059 2.28247 15.0724C1.84899 14.639 1.60547 14.051 1.60547 13.438V4.19229Z",
    stroke: "url(#paint0_linear_157_649)",
    strokeWidth: 2.31143,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_649",
    x1: 10.8512,
    y1: 1.88086,
    x2: 10.8512,
    y2: 15.7495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E80505"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience2);
export default __webpack_public_path__ + "static/media/experience2.c03376a85bea387c013f5d7fd9039545.svg";
export { ForwardRef as ReactComponent };